module.exports = __webpack_public_path__ + "a7f1faafe3b22cec0f9debd748d2c552.svg";